import { createRef } from "react";
import UpdateProcedureFileReviseSection from "../../../../sections/procedureFileSections/updateProcedureFileReviseSection";
import styles from "../../style/index.module.scss";
import ProcedureBlock from "../../../../../base/basicComponents/procedureBlock";
import {
  actions,
  dataStatus,
  deepClone,
  fileTags,
  handleRevisionInfoManatoryCheck,
  proposedChangeTags,
  revisionInfoMandatoryCheck,
  savedInRadioValues,
  procedureJbStatusMap,
} from "../../../../publicDictionaryValues";
import DetailRevisionInformation from "../../../../sections/procedureFileSections/fields/revisionInformationFields/detailRevisionInformation";
import ProcedureDetailService from "../../../../../service/procedureFile/ProcedureDetailService";
import ReviseNewProcedurePending from "../../createNewProcedureProcess/reviseNewProcedurePending";

const procedureFileTableRef = createRef();
const reasonRef = createRef();
const noteRef = createRef();
const procedureFileRef = createRef();
const supportingFileRef = createRef();
const supportingFileTableRef = createRef();
export default class ReviseUpdateProcedurePending extends ReviseNewProcedurePending {
  /* function about control save button disable when procedure file table change */
  setIsRevisionInfoChange = () => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        isRevisionInfoChange: true,
      },
    });
  };

  /* function about control save button disable when procedure file table change */
  cancelIsRevisionInfoChange = () => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        isRevisionInfoChange: false,
      },
    });
  };

  /**
   * function about return page name
   * @returns
   */
  handleReturnPageName = () => {
    return "Revise Update Procedure";
  };

  /**
   * function about update saved in value state
   * @param {string} value current saved in value
   * @param {string} prevValue last saved in value
   */
  // @ts-ignore
  updateSavedInRadioValue = (value: any, prevValue: any) => {
    const dataList =
      this.props.procedureRef.current !== null
        ? deepClone(this.props.procedureRef.current.getDataList())
        : [];
    if (
      (value === savedInRadioValues.serverOnly || value === null) &&
      prevValue !== savedInRadioValues.serverOnly &&
      prevValue !== null
    ) {
      // @ts-ignore
      this.prevProcedureDataList = dataList;
    }
    this.setState({
      savedInState: { ...this.state.savedInState, savedInRadioValue: value },
    });
    dataList.forEach((item: any, index: any) => {
      dataList[index].isError = false;
    });
    // @ts-ignore
    procedureFileTableRef.current?.updateDataList(dataList);
    // @ts-ignore
    this.isTableBorderError = false;
    this.setState({
      pageState: { ...this.state.pageState, isTableBorderError: false },
    });
    this.props.procedureServerPathRef.current.cancelServerPathError();
  };

  /**
   * function about return revision information section
   * @returns
   */
  // @ts-ignore
  handleReturnRevisionInformation = () => {
    return (
      <ProcedureBlock
        testid="procedure-info-block-arrow"
        className={`${styles.approveProcedureFile} revisionInfoSection`}
        child={
          <DetailRevisionInformation
            title="Revision Information"
            updateFileNumLoading={this.props.updateFileNumLoading}
            openLoading={this.props._showLoading}
            hideLoading={this.props._hideLoading}
            accountId={this.props.pageProps.procedureAccountID}
            ref={this.props.revisionInfoRef}
            isDisabledAll={false}
            revisionInfoData={this.props.revisionInfoData}
            initRevisionInfoState={this.props.initRevisionInfoState}
            setIsRevisionInfoChange={this.setIsRevisionInfoChange}
            cancelIsRevisionInfoChange={this.cancelIsRevisionInfoChange}
          />
        }
        isShowArrow={true}
        isOpen={true}
      />
    );
  };

  /**
   * function about return procedure file section
   * @param {object} obj
   * @returns
   */
  handleReturnProcedureFileSection = () => {
    const { currentRole, isDisableAll, procedureReplaceFileRef } = this.props.pageProps;
    const {
      data,
      downloadFile,
      isMount,
      initSavedInSectionState,
      initServerPathSectionState,
      initProcedureTableData,
      updateFileNumLoading,
      procedureSavedInRef,
      procedureServerPathRef,
      procedureRef,
    } = this.props;
    return (
      <ProcedureBlock
        testid="procedure-file-block-arrow"
        className={styles.approveProcedureFile}
        child={
          // @ts-ignore
          <UpdateProcedureFileReviseSection
            sectionProps={{ currentRole, isDisableAll }}
            refs={{
              procedureSavedInRef: procedureSavedInRef,
              procedureServerPathRef: procedureServerPathRef,
              procedureRef: procedureRef,
              procedureFileTableRef,
              reasonRef,
              noteRef,
              procedureFileRef,
              procedureReplaceFileRef,
            }}
            data={data}
            isTableBorderError={(this as any).isTableBorderError}
            handleChangeTableErrorStatus={this.handleChangeTableErrorStatus}
            downloadFile={downloadFile}
            isMount={isMount}
            savedInProps={this.state.savedInState}
            serverPathProps={this.state.serverPathState}
            initSavedInSectionState={initSavedInSectionState}
            initServerPathSectionState={initServerPathSectionState}
            initProcedureTableData={initProcedureTableData}
            cancelIsTableChange={this.cancelIsTableChange}
            setIsTableChange={this.setIsTableChange}
            updateProcedureFileNum={updateFileNumLoading}
            updateSavedInRadioValue={this.updateSavedInRadioValue}
            updateServerPathValue={this.updateServerPathValue}
            _showLoading={this.props._showLoading}
            _hideLoading={this.props._hideLoading}
          />
        }
        isShowArrow={true}
        isOpen={true}
      />
    );
  };

  handleSubmitTip = () => {
    const dataList =
      this.props.procedureRef.current !== null
        ? deepClone(this.props.procedureRef.current.getDataList())
        : [];
    const fileJBStatusList = dataList.map((file: any) => {
      const JBvalue = file.data.find((item: any) => item.name === "jbProcedure")?.value;
      const tagValue = file.data.find((item: any) => item.name === "fileName")?.tagValue;
      return tagValue === fileTags.deleted ? "" : JBvalue;
    });

    const isExistJBFile =
      fileJBStatusList.includes(procedureJbStatusMap["JB"]) &&
      (this.state.savedInState.savedInRadioValue === savedInRadioValues.systemOnly ||
        this.state.savedInState.savedInRadioValue === savedInRadioValues.systemAndClientServer);
    const isProcedureJB = this.props.procedureStatusJB === procedureJbStatusMap["JB"];
    const isClientServerJB =
      (this.state.savedInState.savedInRadioValue === savedInRadioValues.systemAndClientServer ||
        this.state.savedInState.savedInRadioValue === savedInRadioValues.serverOnly) &&
      this.props.clientServerJB === procedureJbStatusMap["JB"];

    if (
      isProcedureJB &&
      !isExistJBFile &&
      !isClientServerJB &&
      this.state.savedInState.savedInRadioValue
    ) {
      this.handleCreateActionClickSectionCheckModal(
        "",
        // @ts-ignore
        this.modalContentLabels.JBStatusChangeWarningLabel,
        this.handleSubmitOkClick,
        this.hideModal
      );
    } else {
      this.handleCreateActionClickSectionCheckModal(
        "",
        // @ts-ignore
        this.modalContentLabels.updateSubmitConfirmModalLabel,
        this.handleSubmitOkClick,
        this.hideModal
      );
    }
  };

  handleRevisionInfoCheck = () => {
    const isRevisonInfoError = handleRevisionInfoManatoryCheck(this.props.revisionInfoRef);
    if (isRevisonInfoError) {
      const revisionInfo = document.getElementsByClassName("revisionInfoSection")[0];
      revisionInfoMandatoryCheck(this.props.revisionInfoRef, revisionInfo);
      // @ts-ignore
      this.handleControlErrorScroll(revisionInfo.offsetTop);
    }
  };

  /* function about click submit button in revise page to scroll page if table has error */
  constrolTableScrollWhenSubmit = (
    isTableError: any,
    procedureFileData: any,
    errorIndexList: any,
    isOnlyHeaderError = false
  ) => {
    const isRevisonInfoError = handleRevisionInfoManatoryCheck(this.props.revisionInfoRef);
    const tableEle = document.getElementsByClassName("reviseProcedureTable")[0];
    const revisionInfo = document.getElementsByClassName("revisionInfoSection")[0];

    if (isRevisonInfoError) {
      this.handleRevisionInfoCheck();
    } else if (isTableError) {
      // @ts-ignore
      if (this.isTableBorderError) {
        if (!isOnlyHeaderError) {
          procedureFileData.forEach((item: any, index: any) => {
            procedureFileData[index].isError = true;
          });
        }
        tableEle !== undefined &&
          this.handleControlErrorScroll(
            // @ts-ignore
            tableEle.offsetTop + tableEle.clientHeight + revisionInfo.clientHeight
          );
        // @ts-ignore
        this.isTableBorderError = true;
        this.setState({
          pageState: { ...this.state.pageState, isTableBorderError: true },
        });
      } else {
        const firstErrorTr = document.getElementById(`table-tr-${errorIndexList[0]}`);
        this.handleControlErrorScroll(
          // @ts-ignore
          firstErrorTr.offsetTop +
            // @ts-ignore
            firstErrorTr.clientHeight +
            revisionInfo.clientHeight
        );
      }
      // @ts-ignore
      procedureFileTableRef.current.updateDataList(procedureFileData);
    } else {
      procedureFileData.forEach((item: any, index: any) => {
        procedureFileData[index].isError = false;
      });
      // @ts-ignore
      this.isTableBorderError = false;
      this.setState({
        pageState: { ...this.state.pageState, isTableBorderError: false },
      });
      this.handleSubmitTip();
    }
  };

  /* function about click submit button in revise page if returned files don't do change */
  handleCheckFileTableHighLight = (
    procedureFileData: any,
    tableErrorList: any,
    isTableError: any
  ) => {
    let errorIndexList: any[] = [];
    let deleteList = [];
    let isOnlyHeaderError = false;
    procedureFileData.map((fileData: any, index: any) => {
      const isReviewed = fileData.data.find((file: any) => file.name === "isReviewed").value;
      const proposedChange = fileData.data.find(
        (file: any) => file.name === "proposedChange"
      ).value;
      const fileTag = fileData.data.find((file: any) => file.name === "fileName").tagValue;
      const status = fileData.data.find((file: any) => file.name === "status").value;
      if (
        !isReviewed &&
        status !== dataStatus.approval &&
        !(
          proposedChange === null ||
          (proposedChange === proposedChangeTags.new && fileTag === fileTags.deleted) ||
          (status === null && proposedChange === proposedChangeTags.new)
        )
      ) {
        errorIndexList = [];
        tableErrorList.push(procedureFileData[index]);
        errorIndexList.push(index);
        isTableError = true;
        procedureFileData[index].isError = true;
      }

      const tagValue = fileData.data.find((file: any) => file.name === "fileName").tagValue;
      if (tagValue === fileTags.deleted) {
        deleteList.push(fileData);
      }
    });

    if (tableErrorList.length === procedureFileData.length && procedureFileData.length > 0) {
      // @ts-ignore
      this.isTableBorderError = false;
      this.setState({
        pageState: { ...this.state.pageState, isTableBorderError: false },
      });
      isTableError = true;
    } else if (
      tableErrorList.length === 0 &&
      (procedureFileData.length === 0 || deleteList.length === procedureFileData.length)
    ) {
      // @ts-ignore
      this.isTableBorderError = true;
      this.setState({
        pageState: { ...this.state.pageState, isTableBorderError: true },
      });
      isTableError = true;
      isOnlyHeaderError = true;
    }

    this.constrolTableScrollWhenSubmit(
      isTableError,
      procedureFileData,
      errorIndexList,
      isOnlyHeaderError
    );
  };

  handleCheckServerPathHighLight = () => {
    this.props.procedureServerPathRef.current.setServerPathError();
    this.props.procedureServerPathRef.current !== null &&
      this.handleControlErrorScroll(this.props.procedureServerPathRef.current.getOffsetTop());
  };

  /* function about click submit button in revise page */
  handleReviseSubmitClickCheck = (procedureFileData: any, tableErrorList: any) => {
    let isTableError = false;
    const isRevisonInfoError = handleRevisionInfoManatoryCheck(this.props.revisionInfoRef);
    if (this.state.savedInState.savedInRadioValue === null) {
      if (isRevisonInfoError) {
        this.handleRevisionInfoCheck();
      } else {
        this.handleSubmitTip();
      }
    } else if (this.state.savedInState.savedInRadioValue === savedInRadioValues.systemOnly) {
      this.handleRevisionInfoCheck();
      this.handleCheckFileTableHighLight(procedureFileData, tableErrorList, isTableError);
    } else if (
      this.state.savedInState.savedInRadioValue === savedInRadioValues.systemAndClientServer
    ) {
      if (isRevisonInfoError) {
        this.handleRevisionInfoCheck();
      } else if (
        this.state.serverPathState.serverPathValue === null ||
        this.state.serverPathState.serverPathValue.trim() === ""
      ) {
        this.handleCheckServerPathHighLight();
      } else {
        this.handleCheckFileTableHighLight(procedureFileData, tableErrorList, isTableError);
      }
    } else if (this.state.savedInState.savedInRadioValue === savedInRadioValues.serverOnly) {
      if (isRevisonInfoError) {
        this.handleRevisionInfoCheck();
      } else if (
        this.state.serverPathState.serverPathValue === null ||
        this.state.serverPathState.serverPathValue.trim() === ""
      ) {
        this.handleCheckServerPathHighLight();
      } else {
        this.handleSubmitTip();
      }
    }
  };

  /* function about click submit or save button to trigger api */
  createProcedureFileTriggerAction = () => {
    ProcedureDetailService.updateProcedureTriggerRevisePageAction(
      // @ts-ignore
      this.para,
      this._triggerSuccess,
      this._triggerError
    );
  };

  handleSaveOrSubmitClickAdjustDeleteFile = (actionType: any, actionName: any) => {
    const deleteIds = this.props.revisionInfoRef.current.state.deleteIds;
    const revisionAttachments = this.props.revisionInfoRef.current.state.currentAttachment.filter(
      (item: any) => !deleteIds.includes(item?.fileId)
    );
    this.props.revisionInfoRef.current.state.currentAttachment = revisionAttachments;

    // @ts-ignore
    this.para = this.props.handleReturnSubmitData({
      actionID: actionType,
      actionName,
      procedureSavedInRef: this.props.procedureSavedInRef,
      procedureServerPathRef: this.props.procedureServerPathRef,
      pageProcedureRef: this.props.procedureRef,
      revisionInfoRef: this.props.revisionInfoRef,
      isLevelCChangeValue: this.props.isLevelCChange,
    });
    this.createProcedureFileTriggerAction();
  };

  /* function about click save button */
  handleSaveClick = () => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        actionID: actions.save,
      },
    });
    // @ts-ignore
    this.isSaveDisabled = true;
    this.props._showLoading();
    this.handleSaveOrSubmitClickAdjustDeleteFile(actions.save, "Save");
  };

  /* function about click submit button in submit modal */
  // @ts-ignore
  handleSubmitOkClick = (actionType: any, actionName: any) => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        isSubmitDisabled: true,
      },
    });
    this.props._showLoading();
    this.hideModal();
    this.handleSaveOrSubmitClickAdjustDeleteFile(actions.revise, "Revise");
  };

  /**
   * function about control save as draft button disabled
   * @param {*} isChange flag about is table change
   * @param {*} savedInRadioValue the value of saved in radio
   */
  controlIsSaveDisabled = (isChange: any, savedInRadioValue: any) => {
    if (this.props.procedureSavedInRef.current !== null) {
      const initSavedInRadioValue = this.props.initSavedInSectionState.savedInRadioValue;
      const { isRevisionInfoChange } = this.state.pageState;
      if (savedInRadioValue === savedInRadioValues.systemAndClientServer) {
        const currentServerPath = this.state.serverPathState.serverPathValue;
        const initServerPath = this.props.initServerPathSectionState.serverPathValue;
        // @ts-ignore
        this.isSaveDisabled =
          !isChange &&
          savedInRadioValue === initSavedInRadioValue &&
          ((currentServerPath === initServerPath && currentServerPath && initServerPath) ||
            (!currentServerPath && !initServerPath)) &&
          !isRevisionInfoChange;
      } else if (savedInRadioValue === savedInRadioValues.systemOnly) {
        // @ts-ignore
        this.isSaveDisabled =
          !isChange && savedInRadioValue === initSavedInRadioValue && !isRevisionInfoChange;
      } else if (savedInRadioValue === null) {
        // @ts-ignore
        this.isSaveDisabled = savedInRadioValue === initSavedInRadioValue && !isRevisionInfoChange;
      } else {
        const currentServerPath = this.state.serverPathState.serverPathValue;
        const initServerPath = this.props.initServerPathSectionState.serverPathValue;
        // @ts-ignore
        this.isSaveDisabled =
          savedInRadioValue === initSavedInRadioValue &&
          ((currentServerPath === initServerPath && currentServerPath && initServerPath) ||
            (!currentServerPath && !initServerPath)) &&
          !isRevisionInfoChange;
      }
    }
  };
}
